/**
 * StoreGridContainer component
 * @returns <StoreGridContainer />
 */

const StoreGridContainer = ({ children }) => {
  return (
    <div className="store-grid">
      <div className="wrapper">
        <div className="store-grid__container">

          {children}
          {/* Children */}
          {/* <FiltersContainer>
            <h3>{title}</h3>

            <form action="">
              <fieldset>
                
              </fieldset>
            </form>
          </FiltersContainer>

          <BoxWithBackgroundContainer {...props} /> */}
        </div>
      </div>
    </div>
  )
}

export default StoreGridContainer